import { render, staticRenderFns } from "./ArchivedPayers.vue?vue&type=template&id=68a0a4cf&scoped=true"
import script from "./ArchivedPayers.vue?vue&type=script&lang=js"
export * from "./ArchivedPayers.vue?vue&type=script&lang=js"
import style0 from "./ArchivedPayers.vue?vue&type=style&index=0&id=68a0a4cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a0a4cf",
  null
  
)

export default component.exports